import { FlexBox, Icon, Text } from '@fable/components'
import { css, cx, useTheme } from '@fable/theme'
import { useStats } from '../../lib/ctx/stats'
import { getInsightText } from '../../lib/utils'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  label?: string
  backgroundColor?: string
  text: string
  color?: string
  accentColor?: string
  noShadow?: boolean
}

export const ReaderInsight = ({
  className,
  label = 'Reader insight',
  text,
  backgroundColor,
  color,
  accentColor,
  noShadow = false,
  ...props
}: Props) => {
  const { colors } = useTheme()
  const theme = useStats((s) => s.theme)
  const textColor = color || colors.uiWhite
  const insight = getInsightText(text, colors.uiWhite)
  const textAccent = accentColor || theme.primary

  return (
    <div
      className={cx(
        css`
          position: relative;
        `,
        className
      )}
      {...props}
    >
      <span
        className={css`
          display: block;
          width: 80%;
          height: 44px;
          position: absolute;
          top: 10%;
          left: 50%;
          transform: translateX(-50%);
          background-color: ${colors.uiBlack};
          box-shadow: ${noShadow
            ? 'none'
            : '0px 0px 120px 0px rgba(0, 0, 0, 1)'};
        `}
      />
      <FlexBox
        className={css`
          position: relative;
          margin-top: 20px;
          padding: 20px 16px 32px;
          width: 100%;
          background-color: ${backgroundColor || theme.bg100};
          border-radius: 16px;
        `}
        flexDirection="column"
      >
        <FlexBox
          className={css`
            margin-bottom: 8px;
            gap: 1px;
          `}
          alignItems="center"
        >
          <Icon
            className={css`
              width: 16px;
              svg {
                transition: fill ease-in-out 0.6s;
              }
            `}
            type="sparkle"
            fill={accentColor}
          />
          <Text
            className={css`
              transition: color ease-in-out 0.6s;
            `}
            type="label"
            sizing="L"
            color={textAccent}
            align="center"
            weight="500"
          >
            {label}
          </Text>
        </FlexBox>
        <Text type="body" sizing="M" color={textColor}>
          {insight}
        </Text>
      </FlexBox>
    </div>
  )
}
